import OrderInvoices from "@iewcasia/Components/OrderInvoices";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import React, { FC } from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: any) => ({
    order: state.pages.orderStatus?.order,
});

type Props = ReturnType<typeof mapStateToProps>;

const OrderStatusInvoices: FC<Props> = ({ order }) => {
    return order ? (
      <OrderInvoices {...order} />
    ) : null;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(OrderStatusInvoices),
    definition: {
        allowedContexts: ["OrderStatusPage"],
        displayName: "Order Invoices",
        group: "Order Status",
    },
};

export default widgetModule;
